import 'unfetch/polyfill'
import { print } from 'graphql'
// TODO this is a little clunky. Export a function from the auth module that others can use thus hiding the vueAuth implementation.
import { vueAuth } from '../store/modules/auth'
import store from '../store'
import { api } from '../config'

const url = api.baseUrl + '/graphql'

function normalizeQuery(query) {
  if (typeof query === 'string') {
    return query;
  }
  return print(query)
}

const handleError = function (gqlResponse, title, dispatch) {
  if (gqlResponse instanceof Promise) {
    gqlResponse.then(json => {
      // Note this is not the http response object, its a graphql response
      console.log(json)
      dispatch('notify', { title: title, message: json.errors })
    })
    .catch(e => {
      console.log(e)
      dispatch('notify', title + ' ' + e)
    })
  } else if (gqlResponse instanceof Error) {
    console.log(gqlResponse.message)
    dispatch('notify', title + ' ' + gqlResponse.message)
  } else {
    console.log(gqlResponse)
    dispatch('notify', title + ' ' + gqlResponse)
  }
}

const query = function (ql, variables) {
  ql = normalizeQuery(ql)
  const token = vueAuth.getToken()
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    },
    body: JSON.stringify({
      query: ql,
      variables: variables
    })
  }).then((response) => {
    if (response.status == 401) {
      store.dispatch('authLogout');
      return Promise.reject('Unauthorized')
    }
    if (response.status == 200 || response.status == 201) {
      return response.json() // This is a promise
    }
    return Promise.reject(response.json().then(json => {
      json.status = response.status
      json.ok = response.ok
      json.bodyUsed = response.bodyUsed
      return Promise.resolve(json)
    }))
  })
}

export default {
  query,
  handleError
}